import type { AxiosInstance } from 'axios';

/** The default template that would lose its flag if another one took it. */
export interface ExistingDefault {
  id: string;
  name: string;
  device_count: number;
}

/**
 * The current default template of one owner (ANEP_CLIENT_ID or a client
 * UUID) for one gateway type, other than `excludeId`. Null when there is
 * none, or when the lookup fails: the backend keeps the rule anyway and
 * answers 409 with a message.
 */
export const findExistingDefault = async (
  axios: AxiosInstance,
  ownerId: string,
  deviceType: string,
  excludeId?: string | null,
): Promise<ExistingDefault | null> => {
  if (!ownerId || !deviceType) return null;
  try {
    const res = await axios.get('/v2/config-templates', {
      params: { client_id: ownerId, device_type: deviceType, limit: 100, page: 1 },
    });
    const items: any[] = res.data?.items ?? [];
    const hit = items.find((it) => it.is_default === true && it.is_active !== false && String(it.id) !== String(excludeId ?? ''));
    return hit ? { id: String(hit.id), name: hit.name, device_count: hit.device_count ?? 0 } : null;
  } catch (err) {
    console.warn('[CONFIG TEMPLATES] default lookup failed:', err);
    return null;
  }
};
